import {css} from "@emotion/react";

import {p, ph} from "@pg-design/helpers-css-strings";
import {getThemeBreakpoint} from "@pg-design/styles-strings";

import {ArticleCategoriesLinksGroup} from "./AricleCategoriesLinksGroup";

const firstColumnList = [
    {name: "Katowice", suffix: "katowice"},
    {name: "Kraków", suffix: "krakow"},
    {name: "Łódź", suffix: "lodz"},
    {name: "Poznań", suffix: "poznan"},
    {name: "Szczecin", suffix: "szczecin"},
    {name: "Warszawa", suffix: "warszawa"}
];
const secondColumnList = [
    {name: "Finanse i kredyty", suffix: "finanse"},
    {name: "Firmy deweloperskie", suffix: "firmy-deweloperskie"},
    {name: "Inwestowanie w nieruchomości", suffix: "inwestowanie-w-nieruchomosci"},
    {name: "Nieruchomości", suffix: "nieruchomosci"},
    {name: "Prawo i podatki", suffix: "prawo-i-podatki"},
    {name: "Wynajem mieszkań", suffix: "wynajem-mieszkan"},
    {name: "Raporty i dane rynkowe", suffix: "raporty"}
];
const thirdColumnList = [
    {name: "Aktualności", suffix: "aktualnosci"},
    {name: "Architektura", suffix: "architektura"},
    {name: "Styl życia", suffix: "styl-zycia"}
];
const fourthColumnList = [
    {name: "Style wnętrz", suffix: "style"},
    {name: "Trendy", suffix: "trendy"},
    {name: "Wyposażenie wnętrz", suffix: "wyposazenie-wnetrz"}
];
const fifthColumnList = [
    {name: "Małe mieszkanie", suffix: "male-mieszkanie"},
    {name: "Porady", suffix: "porady"},
    {name: "Remonty i wykończenia", suffix: "remont"}
];

interface IArticleCategoriesListProps {
    className?: string;
}

export const ArticleCategoriesList = ({className}: IArticleCategoriesListProps) => {
    return (
        <div css={categoriesStyle} className={className}>
            <ArticleCategoriesLinksGroup title="Regionalne" links={firstColumnList} css={categoryStyle} />

            <ArticleCategoriesLinksGroup title="Rynek nieruchomości" links={secondColumnList} css={categoryStyle} />

            <ArticleCategoriesLinksGroup title="Wiadomości" links={thirdColumnList} css={categoryStyle} />

            <ArticleCategoriesLinksGroup title="Wnętrza" links={fourthColumnList} css={categoryStyle} />

            <ArticleCategoriesLinksGroup title="Inne" links={fifthColumnList} css={categoryStyle} />
        </div>
    );
};

const categoriesStyle = css`
    display: flex;
    flex-direction: column;
    ${ph(2)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${p(8, 0)};
        flex-direction: row;
        justify-content: space-between;
    }
`;

const categoryStyle = css`
    flex: 1 1;
    flex-basis: fit-content;
`;
import {css} from "@emotion/react";

import {p, ph} from "@pg-design/helpers-css-strings";
import {getThemeBreakpoint} from "@pg-design/styles-strings";

import {ArticleCategoriesLinksGroup} from "./AricleCategoriesLinksGroup";

const firstColumnList = [
    {name: "Katowice", suffix: "katowice"},
    {name: "Kraków", suffix: "krakow"},
    {name: "Łódź", suffix: "lodz"},
    {name: "Poznań", suffix: "poznan"},
    {name: "Szczecin", suffix: "szczecin"},
    {name: "Warszawa", suffix: "warszawa"}
];
const secondColumnList = [
    {name: "Finanse i kredyty", suffix: "finanse"},
    {name: "Firmy deweloperskie", suffix: "firmy-deweloperskie"},
    {name: "Inwestowanie w nieruchomości", suffix: "inwestowanie-w-nieruchomosci"},
    {name: "Nieruchomości", suffix: "nieruchomosci"},
    {name: "Prawo i podatki", suffix: "prawo-i-podatki"},
    {name: "Wynajem mieszkań", suffix: "wynajem-mieszkan"},
    {name: "Raporty i dane rynkowe", suffix: "raporty"}
];
const thirdColumnList = [
    {name: "Aktualności", suffix: "aktualnosci"},
    {name: "Architektura", suffix: "architektura"},
    {name: "Styl życia", suffix: "styl-zycia"}
];
const fourthColumnList = [
    {name: "Style wnętrz", suffix: "style"},
    {name: "Trendy", suffix: "trendy"},
    {name: "Wyposażenie wnętrz", suffix: "wyposazenie-wnetrz"}
];
const fifthColumnList = [
    {name: "Małe mieszkanie", suffix: "male-mieszkanie"},
    {name: "Porady", suffix: "porady"},
    {name: "Remonty i wykończenia", suffix: "remont"}
];

interface IArticleCategoriesListProps {
    className?: string;
}

export const ArticleCategoriesList = ({className}: IArticleCategoriesListProps) => {
    return (
        <div css={categoriesStyle} className={className}>
            <ArticleCategoriesLinksGroup title="Regionalne" links={firstColumnList} css={categoryStyle} />

            <ArticleCategoriesLinksGroup title="Rynek nieruchomości" links={secondColumnList} css={categoryStyle} />

            <ArticleCategoriesLinksGroup title="Wiadomości" links={thirdColumnList} css={categoryStyle} />

            <ArticleCategoriesLinksGroup title="Wnętrza" links={fourthColumnList} css={categoryStyle} />

            <ArticleCategoriesLinksGroup title="Inne" links={fifthColumnList} css={categoryStyle} />
        </div>
    );
};

const categoriesStyle = css`
    display: flex;
    flex-direction: column;
    ${ph(2)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${p(8, 0)};
        flex-direction: row;
        justify-content: space-between;
    }
`;

const categoryStyle = css`
    flex: 1 1;
    flex-basis: fit-content;
`;
